import { __assign, __rest } from "tslib";
import React from "react";
import { ModalContainer } from "./styles";
export var DefaultModal = function (_a) {
    var children = _a.children, width = _a.width, height = _a.height, borderRadius = _a.borderRadius, position = _a.position, rest = __rest(_a, ["children", "width", "height", "borderRadius", "position"]);
    var modalPosition = {
        "top-left": "top: 0; left:0;",
        top: "top: 0; left: 50%; transform: translateX(-50%);",
        "top-right": "top: 0; right: 0;",
        "center-left": "top: 50%; left: 0; transform: translateY(-50%);",
        center: "top: 50%; left: 50%; transform: translate(-50%, -50%);",
        "center-right": "top: 50%; right: 0; transformY(-50%);",
        "bottom-left": "bottom: 0; left: 0;",
        bottom: "bottom: 0; left: 50%; transform: translateX(-50%);",
        "bottom-right": "bottom: 0; right: 0;"
    };
    return (React.createElement(ModalContainer, __assign({}, rest, { width: width, height: height, borderRadius: borderRadius, position: modalPosition[position || "top"] }), children));
};
//# sourceMappingURL=index.js.map